import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 28,
  },
  path: {
    fill: '#fff',
  },
});

const LogoIcon = () => {
  const classes = useStyles();

  return (
    <svg
      className={classes.svg}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 350 400"
    >
      <path
        className={classes.path}
        d="M273.42,209.43c-12.57,12.57-25.14,25.14-37.71,37.71-15.71,15.71-31.43,31.43-47.14,47.14,15.71,15.71,31.43,31.43,47.14,47.14,15.71-15.71,31.43-31.43,47.14-47.14,4.5-4.5,9.01-9.01,13.51-13.51,10-10,15.62-23.57,15.62-37.71v-86.11c0-14.15-5.62-27.71-15.62-37.71-4.5-4.5-9.01-9.01-13.51-13.51-15.71-15.71-31.43-31.43-47.14-47.14-15.71,15.71-31.43,31.43-47.14,47.14,15.71,15.71,31.43,31.43,47.14,47.14,12.57,12.57,25.14,25.14,37.71,37.71,5.21,5.21,5.21,13.65,0,18.86Z"
      />
      <path
        className={classes.path}
        d="M94.28,105.72c25.01,25.01,39.05,58.92,39.05,94.28s-14.05,69.28-39.05,94.28l47.14,47.14c37.51-37.51,58.58-88.38,58.58-141.42s-21.07-103.91-58.58-141.42c-15.71,15.71-31.43,31.43-47.14,47.14Z"
      />
    </svg>
  );
};

export default LogoIcon;
